<script>
  import { onMount } from 'svelte';
  import request from 'superagent';
  
  export let form_id = "";
  export let values = {};
  export let instant = false;
  export let reset = false;
  export let evolveFunc = (_values) => { return _values;  };
  export let afterFunc = (_message) => { alert(_message); };
  let form = {}
  let csrf = '';
  let message = '';
  
  onMount(() => {
    getForm();
    if (instant) postForm();
  });
  
  function getForm() {
    //if (!(form_id.length)) return;
    //request.get(`/form/${form_id}`).then(resp => { form = resp.body; });
  
    var req = new XMLHttpRequest();
    req.open('GET', `/form/${form_id}`, false);
    req.send(null);
    csrf = req.getResponseHeader('server');
  }
  
  function postForm() {
    let submit = values.id ? request.put : request.post;
    submit(`/form/${form_id}`)
    .send(evolveFunc(values))
    .set("Fsrc", csrf)
    .then(resp => {
      if (reset)
        values = {};
      else
        values.id = resp.body.id;
      if ('success' in resp.body)
        message = resp.body.success;
      if ('error' in resp.body)
        message = resp.body.error;
      afterFunc(message);
    });
  }
</script>
<form action='/form/{form_id}' method='post' novalidate='novalidate'>
<div class='row input-group mb-3'>
<div class='col-12 col-md-6'>
<input aria-label='E-mail pro odběr novinek' bind:value='{values['email']}' class='form-control' id='newsletter' name='email' placeholder='Vaše e-mailová adresa' type='email'>
</div>
<div class='offset-md-6'></div>
<div class='col-12 col-md-4 mt-1'>
<button class='btn btn-primary btn-lg btn-block font-weight-bold' on:click|preventDefault='{postForm}'>
<span class='mr-1 font-weight-bold'>Přihlásit</span>
<i class='fa fa-chevron-right'></i>
</button>
</div>
</div>
</form>
